import { render, staticRenderFns } from "./BaseMensaje.vue?vue&type=template&id=597cc82f"
import script from "./BaseMensaje.vue?vue&type=script&lang=js"
export * from "./BaseMensaje.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports